import {
  login,
  info,
  wechatLogin,
  wechatJoin,
  qqLogin,
  qqJoin,
  getPmUnread,
} from "@/service/user";
const state = {
  token: "Bearer " + localStorage.getItem("WCH-TOKEN"),
  user: null,
  unread: false,
};

const mutations = {
  SET_TOKEN: (state, data) => {
    state.token = data;
  },
  SET_USER: (state, data) => {
    state.user = data;
  },
  SET_UNREAD: (state, data) => {
    state.unread = data;
  },
};

const actions = {
  login({ commit }, user) {
    return new Promise((resolve, reject) => {
      login(user)
        .then((response) => {
          const { data } = response;
          commit("SET_TOKEN", "Bearer " + data.token);
          resolve(response);
      })
        .catch((error) => {
          reject(error);
        });
    });
  },

  read({ commit }) {
    return new Promise((resolve, reject) => {
      // console.info("state");
      // console.info(state);

      // console.info(state.user);

     
        getPmUnread()
          .then((response) => {
            const { data } = response;
            commit("SET_UNREAD", data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      
    });
  },
  wechatLogin({ commit }, data) {
    return new Promise((resolve, reject) => {
      wechatLogin(data)
        .then((response) => {
          const { data } = response;
          commit("SET_TOKEN", "Bearer " + data.token);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  qqLogin({ commit }, data) {
    return new Promise((resolve, reject) => {
      qqLogin(data)
        .then((response) => {
          const { data } = response;
          commit("SET_TOKEN", "Bearer " + data.token);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  wechatJoin({ commit }, data) {
    return new Promise((resolve, reject) => {
      wechatJoin(data)
        .then((response) => {
          const { data } = response;
          commit("SET_TOKEN", "Bearer " + data.token);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  qqJoin({ commit }, data) {
    return new Promise((resolve, reject) => {
      qqJoin(data)
        .then((response) => {
          const { data } = response;
          commit("SET_TOKEN", "Bearer " + data.token);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      info()
        .then((response) => {
          const { data } = response;
          commit("SET_USER", data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  exist({ commit }) {
    return new Promise((resolve, reject) => {
      commit("SET_USER", null);
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
